import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { api, type ApiResult } from './api';

interface ApiOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
  signal?: AbortSignal;
}

/**
 * Hook que envuelve api() inyectando el token del AuthContext.
 * Devuelve una funcion estable (memoizada) que se puede pasar a effects.
 */
export function useApiClient() {
  const { token } = useAuth();
  return useCallback(
    <T>(path: string, opts: ApiOptions = {}): Promise<ApiResult<T>> =>
      api<T>(path, { ...opts, token }),
    [token],
  );
}
